import { useState, useEffect } from "react";
import MobileNavbar from "./MobileNavbar";

const Routes = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Team", path: "/team" },
    { name: "Training", path: "/training" },
    { name: "Contact", path: "/contact" },
    { name: "Login", path: "https://dnduser.com" },
];

export const Header = ({ overlay = false }) => {
    const [isFixed, setIsFixed] = useState(false);

    useEffect(() => {
        if (overlay) return;

        const handleScroll = () => {
            setIsFixed(window.scrollY > 100);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [overlay]);

    const headerClass = [
        "lg:flex hidden items-center w-full z-20 font-ui",
        overlay || isFixed
            ? "fixed top-0 left-0 right-0 transition-all duration-300 ease-in-out"
            : "",
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <>
            <nav
                className={headerClass}
                style={{
                    background: "var(--brand-black)",
                    borderBottom: "1px solid var(--brand-rule)",
                }}
            >
                <div
                    className="w-full flex items-center justify-between gap-6 px-4 sm:px-6 lg:px-8 py-2.5 lg:py-3"
                    id="nav-content"
                >
                    <a href="/" className="flex shrink-0 items-center leading-none">
                        <img
                            className="block max-h-8 md:max-h-10 lg:max-h-11 w-auto"
                            src={
                                "https://ik.imagekit.io/dnddecpho/dndream/DD_LogoGold-300x53_9YWAdjFzX.png?updatedAt=1706110249831"
                            }
                            alt="desktop-logo"
                        />
                    </a>
                    <div className="flex min-w-0 flex-1 flex-wrap items-center justify-end gap-x-4 gap-y-2 sm:gap-x-5 lg:gap-x-7">
                        {Routes.map((route) => (
                            <a
                                key={route.path}
                                className="nav-link whitespace-nowrap text-base lg:text-lg leading-none cursor-pointer"
                                href={route.path}
                            >
                                {route.name}
                            </a>
                        ))}
                    </div>
                </div>
            </nav>
            <MobileNavbar />
        </>
    );
};
